import { Locales } from "@caspeco/casper-ui-library";
import { sv } from "date-fns/locale/sv";
import { nb } from "date-fns/locale/nb";
import { da } from "date-fns/locale/da";
import { IsoCountryCode, LocaleId, LocaleIds } from "../models/user";
import { TFunction } from "i18next";
import { FormatDistanceFn, FormatLong, FormatRelativeFn, LocaleOptions, Localize, Match } from "date-fns";
import { enGB } from "date-fns/locale";
import { fr } from "date-fns/locale";

interface Locale {
	/** The locale code (ISO 639-1 + optional country code) */
	code: string;
	/** The function to format distance */
	formatDistance: FormatDistanceFn;
	/** The function to relative time */
	formatRelative: FormatRelativeFn;
	/** The object with functions used to localize various values */
	localize: Localize;
	/** The object with functions that return localized formats */
	formatLong: FormatLong;
	/** The object with functions used to match and parse various localized values */
	match: Match;
	options?: LocaleOptions;
}

export const getLocale = (countryCode?: LocaleId): { localeString: Locales; locale: Locale } => {
	switch (countryCode) {
		case LocaleIds.SE:
			return { localeString: "sv-SE", locale: sv };
		case LocaleIds.EN:
			return { localeString: "en-GB", locale: enGB };
		case LocaleIds.NOb:
			return { localeString: "nb-NO", locale: nb };
		case LocaleIds.DK:
			return { localeString: "da-DK", locale: da };
		case LocaleIds.FR:
			return { localeString: "fr-FR", locale: fr };
		default:
			return { localeString: "en-GB", locale: enGB };
	}
};

let userLocale = getLocale();

export const setUserLocale = (countryCode?: LocaleId) => {
	if (!countryCode) return userLocale;
	userLocale = getLocale(countryCode);
	return userLocale;
};

export const getUserLocale = () => {
	return userLocale;
};

export const getCurrencyDisplay = (
	countryCode: IsoCountryCode,
	translate: TFunction<"translation", undefined>,
	currencyFormat: string,
) => {
	let currencyCode = "";
	switch (countryCode) {
		case IsoCountryCode.SE:
			currencyCode = "SEK";
			break;
		case IsoCountryCode.US:
			currencyCode = "USD";
			break;
		case IsoCountryCode.NO:
			currencyCode = "NOK";
			break;
		case IsoCountryCode.DK:
			currencyCode = "DKK";
			break;
		case IsoCountryCode.BE:
			currencyCode = "EUR";
			break;
		case IsoCountryCode.EE:
			currencyCode = "EUR";
			break;
		case IsoCountryCode.FI:
			currencyCode = "EUR";
			break;
		case IsoCountryCode.RU:
			currencyCode = "RUB";
			break;
		case IsoCountryCode.NL:
			currencyCode = "EUR";
			break;
		case IsoCountryCode.ES:
			currencyCode = "EUR";
			break;
		default:
			currencyCode = "SEK";
			break;
	}
	return translate(`currency_${currencyCode}_${currencyFormat}`);
};
